import { compose, withStateHandlers, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { optionsForModel } from 'reducers/models/selectors';
import { theme } from 'reducers/dashboard/selectors';
import { setSelectedOptions } from 'reducers/search/actions';
import { selectedOptions } from 'reducers/search/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { difference, concat, includes, filter, find } from 'lodash';

const mapStateToProps = combineSelectors({
  optionsForModel,
  theme,
  selectedOptions,
});

export const setOption = ({
  selectedOptions,
  originalOptions,
  setSelectedOptions,
  setLocalOption,
}) => value => {
  let option = find(originalOptions, o => o.id === value);
  let selected = concat(selectedOptions, option);
  let remainingOptions = difference(originalOptions, selected);
  setSelectedOptions(selected);
  setLocalOption(selected, remainingOptions);
};

export const setLocalOption = () => (selected, remaining) => {
  return {
    search: '',
    selectedOptions: selected,
    filteredOptions: remaining,
    remainingOptions: remaining,
  };
};

export const searchBarStyle = ({ theme }) => ({
  color: `#939393`,
  border: `1px solid ${theme.palette.primary}`,
  height: `2em`,
  width: `90%`,
});

export const selectedOptionStyle = ({ theme }) => ({
  color: theme.palette.primary,
  border: `1px solid ${theme.palette.primary}`,
});

export const filterOption = ({ remainingOptions }) => event => {
  let value = event.target.value.toLowerCase();
  let filtered = filter(remainingOptions, option => {
    let description = option.description.toLowerCase();
    let id = option.id.toLowerCase();
    return includes(id, value) || includes(description, value);
  });
  return { search: event.target.value, filteredOptions: filtered };
};

export const removeOption = ({
  selectedOptions,
  originalOptions,
  setSelectedOptions,
  setLocalOption,
}) => optionId => {
  let option = find(originalOptions, o => o.id === optionId);
  let selected = filter(selectedOptions, sOption => sOption.id !== option.id);
  let remainingOptions = difference(originalOptions, selected);
  setSelectedOptions(selected);
  setLocalOption(selected, remainingOptions);
};

function componentDidMount() {
  let options = this.props.originalOptions;
  let selected = this.props.selectedOptions;
  let remaining = difference(options, selected);
  this.props.setSelectedOptions(selected);
  this.props.setLocalOption(selected, remaining);
}

function componentDidUpdate(prevProps) {
  if (prevProps.model.id !== this.props.model.id) {
    this.props.closeSearch();
  }
}

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['searchPlaceholder'],
  }),
  connect(mapStateToProps, {
    setSelectedOptions,
  }),
  addProps({ selectedOptionStyle, searchBarStyle }),
  withStateHandlers(
    ({ optionsForModel, selectedOptions }) => ({
      search: '',
      originalOptions: optionsForModel,
      remainingOptions: optionsForModel,
      selectedOptions: selectedOptions ? selectedOptions : [],
      filteredOptions: optionsForModel,
    }),
    {
      filterOption,
      setLocalOption,
    },
  ),
  withHandlers({
    setOption,
    removeOption,
  }),
  lifecycle({
    componentDidMount,
    componentDidUpdate,
  }),
);
